import React, { useState } from 'react';
import api from '../config/api';

const PagamentoPix = ({ showAlert, setLoading }) => {
    const [tipoPlano, setTipoPlano] = useState('MENSAL');
    const [qrCodeData, setQrCodeData] = useState(null);
    const [showQrCode, setShowQrCode] = useState(false);

    const DADOS_TESTE = {
        usuarioId: localStorage.getItem('usuarioId') || 1,
        valor: tipoPlano === 'MENSAL' ? 350 : 3850
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            const payload = {
                usuarioId: DADOS_TESTE.usuarioId,
                valor: DADOS_TESTE.valor,
                tipoPagamento: 'PIX',
                tipoPlano: tipoPlano,
                descricao: `Assinatura ${tipoPlano === 'MENSAL' ? 'Mensal' : 'Anual'} - ${new Date().toLocaleDateString('pt-BR')}`
            };

            console.log('Enviando para backend:', payload);

            const response = await api.post('/pagamento', payload);

            if (response.data) {
                showAlert('✅ Pagamento iniciado com sucesso! Escaneie o QR Code com seu celular.', 'success');
                
                // Extrair dados reais do QR Code do backend
                setQrCodeData({
                    qrCodePix: response.data.qrCodePix, // Base64 da imagem
                    copia_colaPix: response.data.copia_colaPix, // String para copiar
                    valor: DADOS_TESTE.valor,
                    statusMP: response.data.statusMP
                });
                setShowQrCode(true);
            }
        } catch (error) {
            console.error('Erro na requisição:', error.response?.data || error.message);
            const errorMessage = error.response?.data?.mensagem || 'Erro ao processar PIX';
            showAlert(errorMessage, 'error');
        } finally {
            setLoading(false);
        }
    };

    const copyToClipboard = () => {
        if (qrCodeData?.copia_colaPix) {
            navigator.clipboard.writeText(qrCodeData.copia_colaPix);
            showAlert('Código PIX copiado para a área de transferência!', 'success');
        }
    };

    return (
        <div className="tab-content active">
            <div className="info-box">
                ℹ️ Escaneie o QR Code com seu celular ou copie a chave PIX para realizar o pagamento
            </div>

            {!showQrCode ? (
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="tipoPlano">Tipo de Plano</label>
                        <select 
                            id="tipoPlano"
                            value={tipoPlano}
                            onChange={(e) => setTipoPlano(e.target.value)}
                            required
                        >
                            <option value="MENSAL">Mensal - R$ 350,00</option>
                            <option value="ANUAL">Anual - R$ 3.850,00</option>
                        </select>
                    </div>

                    <button type="submit" className="btn-submit">
                        💳 Gerar QR Code PIX
                    </button>
                </form>
            ) : (
                qrCodeData && (
                    <div className="qr-code-container">
                        <p style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '20px' }}>
                            Escaneie este código com seu celular:
                        </p>
                        
                        {qrCodeData.qrCodePix ? (
                            <div className="qr-code-placeholder">
                                <img 
                                    src={`data:image/png;base64,${qrCodeData.qrCodePix}`} 
                                    alt="QR Code PIX" 
                                    style={{ maxWidth: '300px', width: '100%', height: 'auto' }}
                                />
                                <p style={{ fontSize: '12px', marginTop: '10px', color: '#666' }}>
                                    Valor: R$ {qrCodeData.valor.toFixed(2)}
                                </p>
                            </div>
                        ) : (
                            <div className="qr-code-placeholder">
                                <div className="qr-code-mock">
                                    <p style={{ fontSize: '18px' }}>📱 Gerando QR Code...</p>
                                    <p style={{ fontSize: '12px', marginTop: '10px' }}>
                                        Valor: R$ {qrCodeData.valor.toFixed(2)}
                                    </p>
                                </div>
                            </div>
                        )}

                        {qrCodeData.copia_colaPix && (
                            <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#f0f0f0', borderRadius: '8px' }}>
                                <p style={{ marginBottom: '10px', color: '#666' }}>Ou copie o código PIX:</p>
                                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                    <input 
                                        type="text" 
                                        value={qrCodeData.copia_colaPix}
                                        readOnly
                                        style={{ 
                                            flex: 1, 
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            fontSize: '12px'
                                        }}
                                    />
                                    <button 
                                        type="button"
                                        onClick={copyToClipboard}
                                        style={{ 
                                            padding: '10px 20px', 
                                            cursor: 'pointer',
                                            background: '#667eea',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '5px'
                                        }}
                                    >
                                        📋 Copiar
                                    </button>
                                </div>
                            </div>
                        )}

                        <button 
                            type="button"
                            onClick={() => setShowQrCode(false)}
                            style={{ 
                                marginTop: '20px',
                                padding: '10px 20px',
                                background: '#f0f0f0',
                                border: '1px solid #ddd',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            ← Voltar
                        </button>
                    </div>
                )
            )}
        </div>
    );
};

export default PagamentoPix;
